import { t } from 'i18next';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { appDanger, appSuccess } from '../app_alerts/slice';
import { getOrganizationSlug } from '../organizations/selectors';
import { postAdditionalPortRequest } from './data';
import { errorReceiveAdditionalPortRequest, failedReceiveAdditionalPortRequest, receiveAdditionalPortRequest } from './slice';
export function* requestAdditionalPortRequest(action) {
    try {
        const { location, portCount } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(postAdditionalPortRequest, organization, location, portCount);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveAdditionalPortRequest());
            yield put(appDanger(`${t('ERROR_REQUEST_ADDITIONAL_PORT', {
                ns: 'Common'
            })}: ${location}.`));
        }
        else if (data) {
            yield put(receiveAdditionalPortRequest());
            yield put(appSuccess(t('SUCCESS_REQUEST_ADDITIONAL_PORT', {
                ns: 'Common'
            })));
        }
        else {
            throw new Error(t('FAILED_REQUEST_ADDITIONAL_PORT', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveAdditionalPortRequest());
    }
}
export function* watchRequestAdditionalPortRequest() {
    yield takeLatest('additionalPortRequest/requestAdditionalPortRequest', requestAdditionalPortRequest);
}
